import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteNotificationsPublicId } from "Infrastructure/Api/Api";
import { notificationsKeys } from "Api/Queries/Notifications/useNotifications";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";
import { allAdminNotificationsKeys } from "Api/Queries/Notifications/useAllNotifications";

const RESOURCES = Resources.Hooks.Notifications;

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useDeleteNotificationMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation<unknown, Error, string>({
    mutationFn: processResponseWithApiProblemDetails((publicId: string) =>
      deleteNotificationsPublicId(publicId),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationsKeys.all });
      queryClient.invalidateQueries({
        queryKey: allAdminNotificationsKeys.all,
      });
      toast.success(t(RESOURCES.Deleted));
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(t(RESOURCES.DeleteError));
      onError?.(error);
    },
  });
};
